import React, { FunctionComponent } from 'react';
import styled, { keyframes } from 'styled-components';
import { MenuItem } from '../MenuUtils';
import { DESKTOP_MENU_PANEL_WIDTH, DisplayMode } from './MenuDesktopContent';
import loadable from '@loadable/component';

const MenuCategoryContent = loadable(() => import('../components/MenuCategoryContent'));

interface Props {
  items: MenuItem;
  menuSelectedPath: MenuItem[];
  currentMenuPath: MenuItem[];
  setMenuSelectedPath: (menuItems: MenuItem[]) => void;
  closeMenu: () => void;
  onClick: (label: string) => void;
}

export const MenuCatalogPanel: FunctionComponent<Props> = ({ items, menuSelectedPath, currentMenuPath, setMenuSelectedPath, closeMenu, onClick }) => {
  const childrenHasChildren = (item: MenuItem) => {
    return !!item.children && item.children.some(item => item.children && item.children.length > 0);
  };

  const itemsToDisplay = childrenHasChildren(items) ? items?.children || [] : [items];

  return (
    <CatalogPanel>
      <BreadCrumb>
        {menuSelectedPath?.map((step, index) => (
          <React.Fragment key={`step_item_${index}`}>
            <span onClick={() => setMenuSelectedPath([step])} className={'step-item'}>
              {step.label}
            </span>
            {index !== menuSelectedPath.length - 1 && <span>{'>'}</span>}
          </React.Fragment>
        ))}
      </BreadCrumb>
      <ItemsContainer>
        {itemsToDisplay?.map((item, index) => (
          <MenuCategoryContent
            key={index}
            item={item}
            menuSelectedPath={menuSelectedPath}
            setMenuSelectedPath={setMenuSelectedPath}
            currentMenuPath={currentMenuPath}
            displayMode={DisplayMode.catalog}
            closeMenu={closeMenu}
            onClick={onClick}
          />
        ))}
      </ItemsContainer>
    </CatalogPanel>
  );
};

export default MenuCatalogPanel;
const CatalogPanel = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  position: fixed;
  right: 0;
  left: ${() => DESKTOP_MENU_PANEL_WIDTH}px;
  top: 0;
  bottom: 0;
  background-color: white;
  z-index: 99999;
  overflow-y: auto;
  justify-items: center;
  animation: ${() => catalogSlideIn(DESKTOP_MENU_PANEL_WIDTH)} 0.5s;
`;

const catalogSlideIn = (left: number) => keyframes`
    from {
        opacity: 0;
        left: ${left - 50}px;
        right: 50px;
    }

    to {
        opacity: 1;
        left: ${left}px;
        right: 0px; 
    }
`;

const ItemsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-row-gap: 50px;
  grid-column-gap: 50px;
  padding: 25px;
  padding-top: 50px;

  @media (max-width: 1825px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 1480px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const BreadCrumb = styled.div`
  display: flex;
  align-items: center;
  column-gap: 5px;
  background-color: white;
  position: fixed;
  width: 100%;
  height: 50px;
  padding-left: 25px;
  z-index: 99;
  transition: all 0.2s;

  .step-item {
    cursor: pointer;
    font-size: 16px;
    transition: color 0.2s ease-in-out;
    &:last-child,
    &:hover {
      font-weight: bold;
    }
  }

  .step-item:hover {
    color: #ff0b75;
  }
`;
